import { render, staticRenderFns } from "./ModalCambiarPropietario.vue?vue&type=template&id=0756d287&scoped=true&"
import script from "./ModalCambiarPropietario.vue?vue&type=script&lang=js&"
export * from "./ModalCambiarPropietario.vue?vue&type=script&lang=js&"
import style0 from "./ModalCambiarPropietario.vue?vue&type=style&index=0&id=0756d287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756d287",
  null
  
)

export default component.exports